import styled from 'styled-components'
import { Radio, Select } from 'antd'

export const RateRadioGroup = styled(Radio.Group)`
  margin-left: 10px;
`

export const RateSelect = styled(Select)`
  margin-left: 10px;
`
